import {
  IArtistDetailResponse,
  IArtistMutationForm,
} from "services/artists/types";

export const artistQueryToForm = (
  artistQuery: IArtistDetailResponse
): IArtistMutationForm => {
  const {
    name,
    artistStatus,
    addedByLabel,
    artistFiles,
    externalIds,
    artistsInBand,
    phoneNumber,
    images,
    ...artist
  } = artistQuery;

  const mainImage = images.find(img => img.isMain);

  return {
    ...artist,
    ...name,
    ...addedByLabel,
    isBandOption: artist.isBand ? 1 : 0,
    statusId: artistStatus,
    externalProfiles: externalIds.map((external) => ({
      id: external.id,
      type: external.type,
      link: external.link,
    })),
    artistsInBand: artistsInBand.map((artist) => ({
      nickname: artist.nickname,
      value: artist.artistId,
    })),
    phoneNumber: phoneNumber ?? { number: "", prefix: "" },
    mainImageId: mainImage?.imageId
  };
};
